import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 }
};

const AboutSection = () => {
  return (
    <section id="about" className="py-20 md:py-28 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12 items-start">
          {/* Photo / placeholder */}
          <motion.div className="lg:col-span-2" {...fadeInUp}>
            <div className="bg-gray-50 aspect-[4/5] relative overflow-hidden corner-cut-br">
              <img
                src="/assets/ollie-headshot.webp"
                alt="Dr Ollie Bell, founder of Kalobrate"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div className="lg:col-span-3" {...fadeInUp}>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-carbon mb-6 tracking-tight">
              PRACTICAL EXPERIENCE, BACKED BY <span className="yellow-highlight text-carbon">RESEARCH</span>
            </h2>

            <div className="space-y-4 text-base text-carbon/80 leading-relaxed mb-8">
              <p>
                Kalobrate was founded by Dr Ollie Bell, a workplace culture and men's health
                specialist with a PhD in behaviour change interventions.
              </p>
              <p>
                Ollie works mainly with organisations in male-dominated and operational sectors.
                His role is to help leaders understand what employees are experiencing, make sense
                of the evidence, and turn it into practical decisions.
              </p>
              <p>
                His work combines research, workplace listening, leadership support and experience
                delivering difficult subjects in a way that people can engage with.
              </p>
            </div>

            <Link
              to="/about"
              className="bg-carbon text-white px-7 py-3.5 font-semibold text-sm hover:bg-carbon/90 transition-colors inline-flex items-center"
              data-testid="about-ollie-btn"
            >
              About Ollie
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
